import * as z from 'zod';

import { stateQuerySchema } from '@/_schemas/generic/state-query-schema';

import { uspsValidationStatusSchema } from './address-validation-schema';
import { addressTypeSchema } from './shared-schema';

import { countryQueryLinkerSchema } from '../../../../_schemas/countries';

export const timeZoneQuerySchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type TimeZoneQuerySchema = z.infer<typeof timeZoneQuerySchema>;

export const geoDataQuerySchema = z.object({
  zip_code: z.string().nullable(),
  place_name: z.string().nullable(),
  state: z.string().nullable(),
  state_abbreviation: z.string().nullable(),
  county: z.string().nullable(),
  country_code: z.string().nullable(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  timezone_id: z.number().nullable(),
  manual_review: z.number().nullable(),
});

export type GeoDataQuerySchema = z.infer<typeof geoDataQuerySchema>;

export const addressQuerySchema = z.object({
  id: z.number(),
  address1: z.string().nullable(),
  address2: z.string().nullable(),
  city: z.string().nullable(),
  country: countryQueryLinkerSchema,
  country_id: z.number(),
  geo_data: geoDataQuerySchema.nullish(),
  geo_data_id: z.number().nullish(),
  type: addressTypeSchema.nullable(),
  postal_code: z.string().nullable(),
  state: stateQuerySchema.nullable(),
  state_id: z.number().nullable(),
  time_zone: timeZoneQuerySchema.nullish(),
  time_zone_id: z.number().nullish(),
  region: z.string().nullable(),
  usps_validation_status: uspsValidationStatusSchema.nullish(),
  usps_validated: z.boolean().nullish(),
});

export type AddressQuerySchema = z.infer<typeof addressQuerySchema>;
